import React from 'react';
import { StyledBodyText, StyledSpanText } from '../../../../../../common/Styleguide/Common/Text';
import { StyledInput } from '../../../../../../common/Styleguide/Common/Input';
import withTheme, { WithTheme } from '../../../../../helpers/WithTheme';
import withSubmission, { WithSubmission } from '../Context/withSubmission';
import { valueFromInput } from '../../../../../../common/input';
import { Link } from 'react-router-dom';
import { MAX_SLUG_LENGTH } from '../../../../../../common/slug';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { InputTable } from '../GameDetailsForm/GameDetailsForm';
import { Checkbox, FormControlLabel } from '@mui/material';
import { COLORS } from '../../../../../../common/Styleguide/Common/colors';
import { GameJamConfig, getCurrentGameJam, getGameJamConfig } from '@crazygames/gamejam/game-jam-config';

interface Props {}

type _Props = Props & WithTheme & WithSubmission;

interface State {
  instructionsDialogOpen: boolean;
  isCollapsed: boolean;
  gameJamConfig?: GameJamConfig;
}

class GameBaseFormName extends React.Component<_Props, State> {
  constructor(props: _Props) {
    super(props);
    const { submission } = this.props;
    this.state = {
      instructionsDialogOpen: false,
      isCollapsed: this.props.isNonEditable,
      gameJamConfig: submission?.gameJamId
        ? getGameJamConfig(submission?.gameJamId)
        : getCurrentGameJam(process.env.REACT_APP_CONFIG !== 'prod'),
    };
  }

  render() {
    return <>{this.renderName()}</>;
  }

  private renderName() {
    const { name } = this.props.baseForm;
    const { disableDetailsEditing, baseFormProblems, attemptedToSave = false } = this.props;
    return (
      <>
        <InputTable>
          <TableBody>
            <TableRow>
              <TableCell>
                <StyledBodyText variant="h3" color="white80" sx={{ margin: 0 }}>
                  Game name <span>* </span>
                </StyledBodyText>
              </TableCell>
              <TableCell>
                <StyledInput
                  value={name || ''}
                  error={baseFormProblems?.includes('NAME_INVALID') || (baseFormProblems?.includes('NAME_MISSING') && attemptedToSave)}
                  disabled={disableDetailsEditing}
                  required
                  onChange={this.handleNameChange}
                />
                {disableDetailsEditing && (
                  <StyledSpanText variant="bodyLower2" color="white80" sx={{ display: 'block', marginBottom: '8px' }}>
                    You can't update this field. Feel free to <Link to="/support">contact us</Link> if you have any question.
                  </StyledSpanText>
                )}

                {baseFormProblems?.includes('NAME_INVALID') && (
                  <StyledBodyText sx={{ m: 0.5 }} variant="bodyLower2" color="error">
                    {`Max length must be lower than ${MAX_SLUG_LENGTH} chars `}
                  </StyledBodyText>
                )}
                {baseFormProblems?.includes('NAME_MISSING') && attemptedToSave && (
                  <StyledBodyText sx={{ m: 0.5 }} variant="bodyLower2" color="error">
                    {`Please fill in the input `}
                  </StyledBodyText>
                )}
                {!disableDetailsEditing && (
                  <StyledBodyText sx={{ m: 0.5 }} variant="bodyLower2" color="white30">
                    {`Must be the same as the title that appears in your game - Max length is ${MAX_SLUG_LENGTH} chars.`}
                  </StyledBodyText>
                )}
                {this.renderGameJam()}
              </TableCell>
            </TableRow>
          </TableBody>
        </InputTable>
      </>
    );
  }

  private handleNameChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const name = valueFromInput(evt);
    this.props.updateBaseForm({ ...this.props.baseForm, name });
  };

  private renderGameJam() {
    const { isNonEditable } = this.props;
    const { gameJamId } = this.props.baseForm;
    const { submission } = this.props;

    if (submission && submission.status !== 'DRAFT') {
      return null;
    }

    if (!this.state.gameJamConfig) {
      return null;
    }

    return (
      <>
        <FormControlLabel
          control={<Checkbox checked={!!gameJamId} onChange={this.handleGameJamChange} />}
          label={
            <span>
              I submit my game as a candidate for the “
              <a href={this.state.gameJamConfig.link} target="_blank" rel="noreferrer">
                {this.state.gameJamConfig.name}
              </a>
              ”
            </span>
          }
          sx={{ color: COLORS.black[10] }}
          disabled={isNonEditable}
        />
      </>
    );
  }

  private handleGameJamChange = (_evt: {}, isGameJam: boolean) => {
    const formUpdate = { ...this.props.baseForm, gameJamId: isGameJam ? this.state.gameJamConfig?.id : undefined };
    if (isGameJam) {
      formUpdate.hasIAP = false;
      if (this.props.baseForm.gameLoaderType === 'iframe') {
        formUpdate.gameLoaderType = null;
        formUpdate.iframeLink = null;
      }
    }
    this.props.updateBaseForm(formUpdate);
  };
}

export default withTheme(withSubmission(GameBaseFormName));
